import {
  GET_LEGENDS_V2,
  GET_SCENARIO_ACCESS_CONFIG,
  GET_SCENARIO_DETAILS,
  GET_SCENARIO_MODULE_SEQ,
  GET_TABLE_DATA_FOR_SCENARIO_LIST
} from 'src/constants';
import { IResponseBase } from 'src/types/response-base';
import { axios } from 'src/lib';
import {
  ISimulatorBreadcrumbs,
  ISimulatorModuleSequence
} from '../types/simulator-module.model';
import { IOpportunity } from '../../planner';
import { IScenarioSummary } from '../../scenarios/types/scenario.model';
import { SCENARIO_LIST } from '../scenario-home-data';
import { IAccessConfigResponse } from '../../common/types/access-configuration.model';

// eslint-disable-next-line import/prefer-default-export
export function fetchModuleSequence(sourceId = 1) {
  return axios
    .get<IResponseBase<ISimulatorModuleSequence[]>>(
      `${GET_SCENARIO_MODULE_SEQ}${sourceId}/`
    )
    .then((response) => response.data);
}

export function fetchDynamicBreadcrumbs(sourceId = 1) {
  return axios
    .get<IResponseBase<ISimulatorBreadcrumbs[]>>(
      `${GET_SCENARIO_MODULE_SEQ}${sourceId}/`
    )
    .then((response) => response.data);
}

export function fetchOpportunityToColorMap(sourceId: number) {
  return axios
    .get(`${GET_LEGENDS_V2}${sourceId}/`)
    .then<IResponseBase<IOpportunity[]>>((response) => response.data);
}

export function fetchScenarioDetails(
  sourceId: number,
  scenarioId: number | string
) {
  return axios
    .get(`${GET_SCENARIO_DETAILS}${sourceId}/${scenarioId}/`)
    .then((response) => ({ ...response.data, status: response.status }));
}

export function fetchCreatedScenario(sourceId: number) {
  return axios
    .get(`${GET_TABLE_DATA_FOR_SCENARIO_LIST}${sourceId}/`)
    .then((response) => response.data);
}

export function fetchScenarioAccessConfig(
  sourceId: number,
  scenarioId: number
) {
  return axios
    .get(`${GET_SCENARIO_ACCESS_CONFIG}${sourceId}/${scenarioId}/`)
    .then<IResponseBase<IAccessConfigResponse>>((response) => response.data);
}
